import '../css/tailwind.css';

import { create as createMenu } from "./components/menu";
import { create as createGitGraph } from "./components/gitgraph";

document.addEventListener('DOMContentLoaded', () => {
    createMenu();
    createGitGraph();
});